"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cryptoSymbolToChainMap = exports.CRYPTO_SYMBOL_DECIMAL_PLACES = exports.CryptoSymbol = exports.CryptoChain = void 0;
/** @TranslateToRust */
var CryptoChain;
(function (CryptoChain) {
    CryptoChain["Bitcoin"] = "Bitcoin";
    CryptoChain["Ethereum"] = "Ethereum";
    CryptoChain["Dogecoin"] = "Dogecoin";
    CryptoChain["Litecoin"] = "Litecoin";
    CryptoChain["Solana"] = "Solana";
    CryptoChain["BitcoinTestnet4"] = "BitcoinTestnet4";
    CryptoChain["EthereumHoodi"] = "EthereumHoodi";
    CryptoChain["TezosTestnet"] = "TezosTestnet";
    CryptoChain["RippleTestnet"] = "RippleTestnet";
    CryptoChain["WorldCoinTestnet"] = "WorldCoinTestnet";
    CryptoChain["SolanaTestnet"] = "SolanaTestnet";
    CryptoChain["PolkadotTestnet"] = "PolkadotTestnet";
    CryptoChain["AlgorandTestnet"] = "AlgorandTestnet";
    CryptoChain["DogeTestnet"] = "DogeTestnet";
    CryptoChain["BerachainTestnet"] = "BerachainTestnet";
    CryptoChain["TronTestnet"] = "TronTestnet";
})(CryptoChain || (exports.CryptoChain = CryptoChain = {}));
/** @TranslateToRust */
var CryptoSymbol;
(function (CryptoSymbol) {
    CryptoSymbol["BTC"] = "BTC";
    CryptoSymbol["ETH"] = "ETH";
    CryptoSymbol["DOGE"] = "DOGE";
    CryptoSymbol["SHIB"] = "SHIB";
    CryptoSymbol["PEPE"] = "PEPE";
    CryptoSymbol["WIF"] = "WIF";
    CryptoSymbol["BONK"] = "BONK";
    CryptoSymbol["LTC"] = "LTC";
    CryptoSymbol["FLOKI"] = "FLOKI";
    CryptoSymbol["TBTC4"] = "TBTC4";
    CryptoSymbol["HTETH"] = "HTETH";
    CryptoSymbol["TXTZ"] = "TXTZ";
    CryptoSymbol["TXRP"] = "TXRP";
    CryptoSymbol["TWLD"] = "TWLD";
    CryptoSymbol["TSOL"] = "TSOL";
    CryptoSymbol["TDOT"] = "TDOT";
    CryptoSymbol["TALGO"] = "TALGO";
    CryptoSymbol["TDOGE"] = "TDOGE";
    CryptoSymbol["TBERA"] = "TBERA";
    CryptoSymbol["TTRX"] = "TTRX";
})(CryptoSymbol || (exports.CryptoSymbol = CryptoSymbol = {}));
/**
 * Native decimal precision for each crypto symbol (i.e. the smallest
 * indivisible unit). BTC = 8 (satoshi), ETH = 18 (wei), etc.
 * Used for rounding amounts after arithmetic to avoid IEEE-754 drift.
 * Type requires BTC so consumers can use CRYPTO_SYMBOL_DECIMAL_PLACES[CryptoSymbol.BTC] as number without fallback.
 */
exports.CRYPTO_SYMBOL_DECIMAL_PLACES = {
    [CryptoSymbol.BTC]: 8,
    [CryptoSymbol.TBTC4]: 8,
    [CryptoSymbol.ETH]: 18,
    [CryptoSymbol.HTETH]: 18,
};
exports.cryptoSymbolToChainMap = {
    [CryptoSymbol.BTC]: CryptoChain.Bitcoin,
    [CryptoSymbol.ETH]: CryptoChain.Ethereum,
    [CryptoSymbol.LTC]: CryptoChain.Litecoin,
    [CryptoSymbol.DOGE]: CryptoChain.Dogecoin,
    [CryptoSymbol.SHIB]: CryptoChain.Ethereum,
    [CryptoSymbol.PEPE]: CryptoChain.Ethereum,
    [CryptoSymbol.WIF]: CryptoChain.Solana,
    [CryptoSymbol.BONK]: CryptoChain.Solana,
    [CryptoSymbol.FLOKI]: CryptoChain.Ethereum,
    [CryptoSymbol.TBTC4]: CryptoChain.BitcoinTestnet4,
    [CryptoSymbol.HTETH]: CryptoChain.EthereumHoodi,
    [CryptoSymbol.TXTZ]: CryptoChain.TezosTestnet,
    [CryptoSymbol.TXRP]: CryptoChain.RippleTestnet,
    [CryptoSymbol.TWLD]: CryptoChain.WorldCoinTestnet,
    [CryptoSymbol.TSOL]: CryptoChain.SolanaTestnet,
    [CryptoSymbol.TDOT]: CryptoChain.PolkadotTestnet,
    [CryptoSymbol.TALGO]: CryptoChain.AlgorandTestnet,
    [CryptoSymbol.TDOGE]: CryptoChain.DogeTestnet,
    [CryptoSymbol.TBERA]: CryptoChain.BerachainTestnet,
    [CryptoSymbol.TTRX]: CryptoChain.TronTestnet,
};
